// extracted by mini-css-extract-plugin
var _1 = "OrderSummary_container__dH3fx";
var _2 = "OrderSummary_footnote__YcDJP";
var _3 = "OrderSummary_shippingCost__R6wnm";
var _4 = "OrderSummary_shippingCostContainer__76kP1";
var _5 = "OrderSummary_sum__rIB5N";
var _6 = "OrderSummary_title__UuH-G";
var _7 = "OrderSummary_total__fAW++";
export { _1 as "container", _2 as "footnote", _3 as "shippingCost", _4 as "shippingCostContainer", _5 as "sum", _6 as "title", _7 as "total" }
